import { TbCircleCheck, TbCircleX } from "react-icons/tb";
import { useEffect } from "react";
import { PageHeaderWithBack } from "../../../Components/Molecules";
import { useBalance } from "../../../Hooks/useBalance";
import ReceiptDetails from "../../../Components/Molecules/ReceiptModal/receiptDetails";

export const FinalStepPayment = ({
  paymentSuccess,
  paymentData,
  refreshStep,
}) => {
  const { getBalance: refreshBalance } = useBalance();

  useEffect(() => {
    paymentSuccess === true && refreshBalance();
  }, [paymentSuccess, refreshBalance]);

  return (
    <div className="w-full">
      <PageHeaderWithBack
        title={paymentSuccess ? "Pagamento concluído" : "Pagamento não concluído"}
        subTitle={
          paymentSuccess
            ? "Seu pagamento foi processado com sucesso."
            : "Não foi possível concluir o pagamento. Tente novamente."
        }
        onBack={refreshStep}
      />

      {paymentSuccess === true ? (
        <div className="app-card p-4 md:p-6">
          <div className="mb-6 flex items-center justify-center gap-2 text-center text-lg font-semibold text-brand-dark md:text-xl">
            <span>Pagamento realizado com sucesso</span>
            <TbCircleCheck className="h-7 w-7 shrink-0 text-emerald-600" aria-hidden />
          </div>
          <ReceiptDetails receipt={paymentData} noModal={true} />
        </div>
      ) : (
        <div className="app-card flex min-h-[40vh] flex-col items-center justify-center p-8 text-center">
          <TbCircleX className="mb-3 h-12 w-12 text-red-500" aria-hidden />
          <h4 className="text-xl font-semibold text-brand-dark md:text-2xl">
            Pagamento não concluído
          </h4>
          <p className="mt-2 max-w-md text-sm text-gray-500">
            Verifique os dados do boleto e tente novamente.
          </p>
        </div>
      )}
    </div>
  );
};
